export default __webpack_public_path__ + "static/Concept_5-ce14b86827613b40ce8301888c12d80b.jpg";